import {
    Button,
    Heading,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalHeader,
    Tab,
    TabList,
    TabPanels,
    Tabs,
    Text,
} from '@chakra-ui/react'

import { useAddPlayerContext } from '@contexts/AddPlayerContext'

import { ExistingPlayerTabPanel } from './ExistingPlayerTabPanel'
import { FakePlayerTabPanel } from './FakePlayerTabPanel'

const TABS = {
    FAKE: 'FAKE',
    EXISTING: 'EXISTING',
} as const

type TTab = (typeof TABS)[keyof typeof TABS]

const TABS_INDEXES: Record<TTab, number> = {
    [TABS.FAKE]: 0,
    [TABS.EXISTING]: 1,
} as const

export function AddPlayerModalContent() {
    const { isEditPlayer, handleSavePlayer, isSaveDisabled, resetNewPlayer, isRealPlayer } = useAddPlayerContext()

    const defaultTabIndex = isEditPlayer && isRealPlayer ? TABS_INDEXES[TABS.EXISTING] : TABS_INDEXES[TABS.FAKE]

    const handleTabChange = () => {
        if (!isEditPlayer) {
            resetNewPlayer()
        }
    }

    return (
        <ModalContent className="add-player-modal">
            <ModalHeader>
                <Heading size="md" fontStyle="italic">
                    {isEditPlayer ? 'EDIT PLAYER' : 'CREATE NEW PLAYER'}
                </Heading>
            </ModalHeader>
            <ModalCloseButton />
            <ModalBody pb={12}>
                <Tabs defaultIndex={defaultTabIndex} onChange={handleTabChange} isFitted>
                    <TabList>
                        <Tab isDisabled={isEditPlayer && isRealPlayer}>
                            <Text fontWeight="bold">{TABS.FAKE}</Text>
                        </Tab>
                        <Tab>
                            <Text fontWeight="bold">{TABS.EXISTING}</Text>
                        </Tab>
                    </TabList>

                    <TabPanels>
                        <FakePlayerTabPanel />
                        <ExistingPlayerTabPanel />
                    </TabPanels>
                </Tabs>
                <Button
                    className="add-player-modal-save-button"
                    variant="green"
                    width="100%"
                    isDisabled={isSaveDisabled}
                    onClick={() => handleSavePlayer()}>
                    Save
                </Button>
            </ModalBody>
        </ModalContent>
    )
}
